import { Injectable } from '@angular/core';

import { RouteOverviewViewModel } from '../viewModels/route-overview.viewModel';
import { JobDomainService } from '../../domain/services/job/job.domain.service';
import { Job } from '../../domain/models/job';
import { JobStatus } from '../../domain/enums/jobStatus';
import { Ordering } from '../../domain/enums/ordering';
import { Observable } from 'rxjs/Observable';

import * as _ from 'lodash';
import { AlertDomainService } from '../../domain/services/alert/alert.domain.service';
import { Alert } from '../../domain/models/alert';
import { ConfigService } from '../../../utils/config-service';

@Injectable()
export class RouteOverviewService {
  private lastOrdering: Ordering;

  constructor(private jobDomainService: JobDomainService, private alertDomainService: AlertDomainService, private configService: ConfigService) {
  }

  getRoutes(): Observable<RouteOverviewViewModel[]> {
    return this.jobDomainService.getAllJobs()
      .map((jobs: Job[]) => {
        let routes = jobs.map((job: Job) => new RouteOverviewViewModel(job));
        return routes;
      });
  }

  getArchivedRoutes(): Observable<RouteOverviewViewModel[]> {
    return this.jobDomainService.getAllArchivedJobs()
      .map((jobs: Job[]) => {
        let routes = jobs.map((job: Job) => new RouteOverviewViewModel(job));
        return routes;
      }, (error: any) => {
        throw error;
      });
  }

  deleteRoute(route: RouteOverviewViewModel): Observable<boolean> {
    return this.jobDomainService.deleteJob(route.id);
  }

  stopRoute(route: RouteOverviewViewModel): Observable<boolean> {
    return this.jobDomainService.stopJob(route.id);
  }

  archiveRoute(route: RouteOverviewViewModel): Observable<any> {
    return this.jobDomainService.archiveJob(route.id, !route.archived);
  }

  shareRoute(route: RouteOverviewViewModel): Observable<string> {
    return this.jobDomainService.shareJob(route.id, true).map((key) => this.configService.getEnv('jobApi').replace('job', 'viewer') + 'single-job/' + key);
  }

  getSharingLink(key: string): string {
    return this.configService.getEnv('jobApi').replace('job', 'viewer') + 'single-job/' + key;
  }

  unshareRoute(route: RouteOverviewViewModel): Observable<string> {
    return this.jobDomainService.shareJob(route.id, false);
  }

  setLastOrderMethod(ordering: Ordering) {
    this.lastOrdering = ordering;
  }

  getLastOrderMethod(): Ordering {
    return this.lastOrdering;
  }

  getAlertsForUser(): Observable<{} | Alert[]> {
    return this.alertDomainService.getAlertsByUser();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-overview/services/route-overview.service.ts